import {
  GET_STATIC_SCREEN_REQUEST,
  GET_STATIC_SCREEN_SUCCESS,
  GET_STATIC_SCREEN_FAILURE,

  GET_STATIC_CONTENT_SCREEN_REQUEST,
  GET_STATIC_CONTENT_SCREEN_SUCCESS,
  GET_STATIC_CONTENT_SCREEN_FAILURE,
} from 'Store/constants';
  
const initialState = {
  data: [],
  content: {},
  isLoading: null,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STATIC_SCREEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
  
    case GET_STATIC_SCREEN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };
  
    case GET_STATIC_SCREEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case GET_STATIC_CONTENT_SCREEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
  
    case GET_STATIC_CONTENT_SCREEN_SUCCESS:
      return {
        ...state,
        content: action.payload,
        isLoading: false,
        error: null
      };
  
    case GET_STATIC_CONTENT_SCREEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
  
    default:
      return state;
  }
};
  